module.exports = __webpack_public_path__ + "static/media/chevron-left.400430f5.svg";